import type { FaireProductEntity } from "../../entity_types/product";

export const p_z67nypuv9s: FaireProductEntity = {
  token: "p_z67nypuv9s",
  type: "product",
  name: "Milk Chocolate Sea Salt Caramels Gift Box",
  brandName: "Coblentz Chocolate Company",
  imageUrl:
    "https://cdn.faire.com/fastly/89b8832e2c0c5ac99d80d96053ddf15bfdc8c60d5d3f78b37139330e4d5db331.jpeg",
  priceDollars: 4.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/77babe99fcdad9d756a49e6f70d74a1c96016b5a27e37429ee45a4f49895fb6d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
